module.exports = __webpack_public_path__ + "static/media/si.761af351.svg";